var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAreaCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28ZM14 7.33333H20.6667V14.1033H14V7.33333ZM11.6772 19.8251L15.0472 22L17.99 20.8734H20.6667V15.2317H18.4444V16.36H19.5556V19.745H17.7878L15.175 20.7453L11.8783 18.6173L8.44444 19.4409V8.46167H11.7778V9.59H12.8889V7.33333H7.33333V20.8672L11.6772 19.8251ZM12.8889 10.7183H11.7778V12.975H12.8889V10.7183ZM12.8889 14.1033V15.2317H14V16.36H11.7778V14.1033H12.8889ZM17.3333 15.2317H15.1111V16.36H17.3333V15.2317Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAreaCircle);
export default __webpack_public_path__ + "static/media/ic-area-circle.9eab73204aa65dd08daaad753c51a2df.svg";
export { ForwardRef as ReactComponent };